import { api } from '../api';
import moment from '../../libs/moment';
import { prepareBaselineTasks } from './helpers';
import rights from '../../components/rights';

export default {
  async fetchBaselines({ dispatch, commit, rootGetters }, projectId) {
    const accessToGanttChart = projectId ? rights.project.hasRight(projectId, 'gantt_chart') : false;

    if ((rootGetters.isBase || rootGetters.isExport) && accessToGanttChart) {
      try {
        const { data: baselines } = await api.get(`/history/baseline/${projectId}?time=${Date.now()}`);

        commit('setProjectBaselines', { projectId, baselines });
        dispatch('setEnabledBaselineFromActivitySettings', projectId);

        return Promise.resolve(baselines);
      } catch (e) {
        return Promise.reject(e);
      }
    }

    return Promise.resolve();
  },

  setEnabledBaselineFromActivitySettings({ commit, rootGetters }, projectId) {
    const userBaselines = rootGetters['user/getActivitySettings']('baselines');

    if (!userBaselines) return;

    const projectEnabledBaseline = userBaselines[projectId];

    if (!projectEnabledBaseline) return;

    commit('enableBaseline', projectEnabledBaseline);
  },

  async createBaseline({ commit }, { ganttId, eventId = null }) {
    try {
      const baseline = {
        gantt_id: ganttId,
        event_id: eventId,
        name: eventId ? null : moment().format('MMM D, YYYY H:mm'),
      };

      const { data } = await api.post('/history/baseline', baseline);

      commit('addBaseline', data);

      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },

  async changeBaseline({ commit }, updatedBaseline) {
    try {
      await api.put(`/history/baseline/${updatedBaseline.id}`, updatedBaseline);

      commit('updateBaseline', updatedBaseline);

      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  },

  async deleteBaseline({ commit }, baseline) {
    try {
      await api.delete(`/history/baseline/${baseline.id}`);

      commit('removeBaseline', baseline);

      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  },

  async getBaselineData({ state, commit }, { projectId, eventId }) {
    if (state.projectBaselineData[projectId]?.[eventId]) {
      return state.projectBaselineData[projectId][eventId];
    }

    try {
      const { data } = await api.get(`/history/baseline/${eventId}/${projectId}`);

      data.tasks = prepareBaselineTasks(data);
      if (!data.userCustomColumnsData) {
        data.userCustomColumnsData = {
          columns: [],
          id: projectId,
          values: [],
        };
      }

      commit('addProjectBaselineData', { projectId, eventId, data });

      return data;
    } catch (e) {
      return Promise.reject(e);
    }
  },
};
